import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ad21695cd1a282461bc911e5a27939c96b from "./generated-d0da6869-123d-46b1-b66b-3aa18cad5d80.json";

import a0f99140ce071c03c2eb482f51d7613b5b from "./generated-9eee9d66-b7c1-46c0-b2c5-67ab89560378.json";

import af42d4c49999fc224421ed610058f66c5b from "./generated-d9579050-20fa-473b-8bcf-bd5c05177843.json";

import ab3a3d65026d27d81ec502bc5a80d13deb from "./generated-2efb4593-3dde-4ce6-9865-5a5ca0a45163.json";

import afd2303eb1c119a76458afb64b0f15cc0b from "./generated-01e33ef6-33fb-4597-aea9-63fa1626d81e.json";

import add9caa366479850798fd3ff627865133b from "./generated-70844189-4312-4844-b7bd-5968e8672461.json";

import a850e23e1b8172a1f7c3ba5dc8391869cb from "./generated-7f03f4f1-1953-404b-8e14-8e512af5da40.json";

import af88924a2bfe1d77351fe531e1ed8e198b from "./generated-a7e41b10-3032-4c86-9469-74650d8aac5d.json";

import a950eceff37c5db4c59a293596f5888aeb from "./generated-5a6d0d95-147d-4b19-b044-62aa8305ada2.json";

import a026bd553f10bb64d911edcda63d55f36b from "./generated-9c3dbabb-bceb-43c1-822c-2fdd444b1c4b.json";

import ab82876d298dcdfc55cdd8a599ad4ec0db from "./generated-d5c7b0d8-e8c5-42e8-89da-1f8eb98e889b.json";

import a6352f6250e43b47bc95f2e849d9c5a0cb from "./generated-01d0ec07-4738-4eb3-9f79-5e66f0661c85.json";

import afcc0f480bc199314f63fb3316e5c95ffb from "./generated-c9e44f95-f8cc-4ae9-ab43-775394c5515c.json";

import a4e1977682fe2e038a4c0ad73c071325eb from "./generated-9196c0c9-f176-4f1d-b9d6-6d2abe0724b5.json";

import a6ceb0fbb74fa3c6a9fe962cec8878838b from "./generated-66d55487-148d-43cc-b962-86890cc6f618.json";

import ac609a9487116f074e1b0f98bbdee0f67b from "./generated-738487e4-e892-4cea-8bab-a28a26f2e9d6.json";

import a29cdaaeb2aca0d6c9f68d67cd7f10505b from "./generated-37a0870d-fe02-4dea-9d28-92e9aceab9b6.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ad21695cd1a282461bc911e5a27939c96b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a0f99140ce071c03c2eb482f51d7613b5b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af42d4c49999fc224421ed610058f66c5b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ab3a3d65026d27d81ec502bc5a80d13deb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(afd2303eb1c119a76458afb64b0f15cc0b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(add9caa366479850798fd3ff627865133b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a850e23e1b8172a1f7c3ba5dc8391869cb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(af88924a2bfe1d77351fe531e1ed8e198b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a950eceff37c5db4c59a293596f5888aeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a026bd553f10bb64d911edcda63d55f36b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ab82876d298dcdfc55cdd8a599ad4ec0db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a6352f6250e43b47bc95f2e849d9c5a0cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a950eceff37c5db4c59a293596f5888aeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(afcc0f480bc199314f63fb3316e5c95ffb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a4e1977682fe2e038a4c0ad73c071325eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a950eceff37c5db4c59a293596f5888aeb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a6ceb0fbb74fa3c6a9fe962cec8878838b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ac609a9487116f074e1b0f98bbdee0f67b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a29cdaaeb2aca0d6c9f68d67cd7f10505b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a6ceb0fbb74fa3c6a9fe962cec8878838b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */